<div class="m-badge c2 {{ styleClass() }}">{{ label() }}</div>
